import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import MentionsLegales from "./pages/MentionsLegales";
import Confidentialite from "./pages/Confidentialite";
import ReserverVisite from "./pages/ReserverVisite";
import VisiteManage from "./pages/VisiteManage";
import { ScrollToTop } from "./components/site/ScrollToTop";

const HrApp = lazy(() => import("./hr/HrApp"));

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/confidentialite" element={<Confidentialite />} />
        <Route path="/reserver-visite" element={<ReserverVisite />} />
        <Route path="/visite/:token" element={<VisiteManage />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/app/*" element={<Suspense fallback={null}><HrApp /></Suspense>} />
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
